import { render, staticRenderFns } from "./ImapSettings.vue?vue&type=template&id=0542988c"
import script from "./ImapSettings.vue?vue&type=script&lang=js"
export * from "./ImapSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports